import { Model } from "@/lib/Model.ts"

type Extension<T> = {
  deps: unknown[]
  value: T
  touched: boolean
}

export class CollectionModelExtender {
  extensions = new Map<unknown, Extension<unknown>>()

  resetTouch() {
    this.extensions.forEach(it => {
      it.touched = false
    })
  }

  get<T>(key: unknown, deps: unknown[], create: () => T): T {
    const existing = this.extensions.get(key) as Extension<T> | undefined
    if (existing && this.depsMatch(deps, existing.deps)) {
      existing.touched = true
      return existing.value
    } else {
      const value = create()
      this.extensions.set(key, { deps, value, touched: true })
      return value
    }
  }

  clearUntouched() {
    const removeKeys: unknown[] = []
    this.extensions.forEach((it, key) => {
      if (!it.touched) {
        removeKeys.push(key)
      }
    })
    for (const key of removeKeys) {
      const existing = this.extensions.get(key)
      if (existing && existing.value instanceof Model) {
        existing.value.terminate()
      }
      this.extensions.delete(key)
    }
  }

  private depsMatch(deps: unknown[], otherDeps: unknown[]) {
    if (deps.length !== otherDeps.length) {
      return false
    }
    for (let i = 0; i < deps.length; i++) {
      if (deps[i] !== otherDeps[i]) {
        return false
      }
    }

    return true
  }
}